import { Component, inject, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';

import { ButtonColors } from '@ed---interne/ng-uui-components';

import { AuthState } from 'src/app/core/states/auth.state';
import { OrganizationState, StudyType } from '../../admin/organization/organization.state';

import {
    CC_CONSTANTS,
    ConcessionControlStatus,
    CC_STATUS_CONSTANTS,
} from '../concessioncontrol/assets/constants';
import { ConcessionControl } from '../../..//core/models/concession-control.model';

import { SidenavService } from '../../../shared/services/sidenav.service';
import { Organization } from 'src/app/core/models/organization.model';
import { User } from 'src/app/core/models/user.model';
import { CracMap } from 'src/app/core/models/crac-map.model';
import { CracMapStatus } from '../cracmap/assets/constants';

@UntilDestroy()
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
    public StudyType = StudyType;
    private prefixPath: string = '/main';
    private _organizationName = '';
    private _loggedUser: User | null = null;
    public currentOrganization$: Observable<Organization | null> = inject(Store).select(
        OrganizationState.currentOrganization,
    );
    public concessionControls: ConcessionControl[] = [];
    public cracMaps: CracMap[] = [];
    public _loggedUser$: Observable<User | null> = inject(Store).select(AuthState.loggedUser);

    public buttonColors = ButtonColors;
    public statusOptions = CC_STATUS_CONSTANTS;

    public concessionControlStatus = ConcessionControlStatus;
    public cracMapStatus = CracMapStatus;

    constructor(
        private router: Router,
        private readonly store: Store,
        private readonly sidenavService: SidenavService,
    ) {
        // make sure sidenav is not display on this page
        this.sidenavService.setTopMenuItems([]);

        combineLatest([this.currentOrganization$, this._loggedUser$])
            .pipe(untilDestroyed(this))
            .subscribe(([organization, loggedUser]) => {
                //For Admin mode, we need organizationId in url : ( /main/{organzationid}/)
                if (organization?.id && loggedUser?.isAdmin) {
                    this.prefixPath = `/main/${organization.id}`;
                }

                if (organization?.concessionControls) {
                    this.concessionControls = organization.concessionControls.sort(
                        (a, b) => b.year - a.year,
                    );
                }
                if (organization?.cracMaps) {
                    this.cracMaps = organization.cracMaps.sort((a, b) => b.year - a.year);
                }

                this._organizationName = organization?.name || '';
                this._loggedUser = loggedUser;
            });
    }

    openConcessionControl(year: number) {
        void this.router.navigate([`${this.prefixPath}/cc/${year}/${CC_CONSTANTS.welcome.path}`]);
    }

    getBadgeLabel(statusId: number): string {
        const option = this.statusOptions.find((option) => option.value === statusId);
        return option ? option.label : '';
    }

    getBadgeClass(status: number): string {
        switch (status) {
            case ConcessionControlStatus.AWAITING_THE_ANNUAL_ORDER:
                return 'pending';
            case ConcessionControlStatus.WAITING:
                return 'inProgress';
            case ConcessionControlStatus.PROCESSING:
                return 'inProgress';
            default:
                return 'available';
        }
    }

    openCracMap(year: number) {
        void this.router.navigate([`${this.prefixPath}/cracmap/${year}`]);
    }

    public contact(type: StudyType, year: Number) {
        const to = 's.tailland@aecenergie.fr';
        const studyType = type === StudyType.CC ? 'Contrôle de concession' : 'Cartes CRAC';
        const mailSubject = `${this._organizationName} - Demande d'informations - ${studyType} ${year}`;
        const mailContent = `Bonjour,
Je me permets de vous contacter via l'outil de suivi de contrôle de concession concernant une prestation de ${studyType} pour l'exercice ${year}:
[Espace dédié pour personnaliser le message ]
Merci d'avance pour votre retour.
Cordialement,
${this._loggedUser?.firstname} ${this._loggedUser?.lastname}
${this._organizationName}
${this._loggedUser?.mail}`;

        const mailTo = `mailto:${to}?subject=${encodeURI(mailSubject)}&body=${encodeURI(mailContent)}`;
        const mail = document.createElement('a');
        mail.href = mailTo;
        mail.click();
    }
}
